import * as Yup from 'yup';

const templateContent = Yup.string()
  .trim()
  .required('Content is required');

export default templateContent;
